import { EPersonalizationSeverity } from "@/types/backoffice/dto/personalization/personalization-severity-dto.ts";
import { EPersonalizationSupportType } from "@/types/backoffice/dto/personalization/personalization-support-type-dto.ts";

const comfortLocale = {
  comfort: {
    contextual: {
      cancel: "Annuler",
    },
    title: "Problème Confort/Technique",
    history: "Historique",
    isTechnicalOrComfort: "Est-ce que la demande concerne un problème technique ou de confort ?",
    technical: "Technique",
    comfort: "Confort",
    isWholeHouse: "Est-ce que la demande concerne tout le logement ?",
    yes: "Oui",
    no: "Non",
    callSeverity: "Gravité de l'appel",
    comment: "Commentaire",
    incompatibility: "Incompatibilité",
    cta: "Soumettre la personnalisation",
    selectDevices: "Sélection des appareils",
    severities: {
      [EPersonalizationSeverity.NORMAL]: "Modéré",
      [EPersonalizationSeverity.NORMAL_LINK]: "Modéré",
      [EPersonalizationSeverity.HIGH]: "Élevé",
      [EPersonalizationSeverity.HIGH_LINK]: "Élevé",
      [EPersonalizationSeverity.SITE_DEACTIVATION_WITH_TERMINATION]: "Désactivation en retirant l’accès à MyVoltalis",
      [EPersonalizationSeverity.DISABLE_LINK]: "Désactivation (Voies)",
      [EPersonalizationSeverity.DISABLE_SITE_FOR_21_DAYS]: "Désactivation pour 21 jours",
      [EPersonalizationSeverity.SITE_DEACTIVATION]: "Désactivation en autorisant l’accès à MyVoltalis",
    },
    types: {
      [EPersonalizationSupportType.COMFORT]: "Confort",
      [EPersonalizationSupportType.TECHNICAL]: "Technique",
    },
  },
};

export type ComfortLocale = typeof comfortLocale;
export default comfortLocale;
